// Build-time flags for the web CRM SPA.
//
// CONTRACT_BUILDER_ENABLED mirrors the Worker's CONTRACT_BUILDER_ENABLED flag
// (src/crm/contract-builder-flag.ts). The in-repo contract builder is archived —
// client contracts now live in the Monjur set (ourterms.live), incorporated via
// each SuperOps Order's Exhibit A. When this is false (the default: the VITE_
// var is unset in the deploy build) the builder's nav/menu entry points are
// hidden. The Worker also hard-gates the underlying routes, so this is the
// presentation half of a defense-in-depth pair.
// See docs/adr/ADR-archive-contract-builder.md.
export const CONTRACT_BUILDER_ENABLED =
  import.meta.env.VITE_CONTRACT_BUILDER_ENABLED === "true";
